import shipperType from "./publicShippersTypes";

const initialState = {
  allPublicShippers: {},
  filterPublicShippersData: {},
  loading: false,
  searching: false,
  filtering: false,
  approving: false,
  shipper: {},
  myShippers: {},
  emptyShipper: {},
  filterNoPage: [],
  search: [],
  reloadShipper: false,
  setShipper: {},
};
export default function PublicShippersReducer(state = initialState, action) {
  switch (action.type) {
    case shipperType.GET_ALL_PUBLIC_SHIPPERS:
      return {
        ...state,
        allPublicShippers: action.payLoad?.data,
      };
    case shipperType.SHOW_SHIPPERS:
      return {
        ...state,
        shipper: action.payLoad?.data,
      };
    case shipperType.SHOW_MY_SHIPPERS:
      return {
        ...state,
        myShippers: action.payLoad?.data,
      };
    case shipperType.FILTER_PUBLIC_SHIPPERS:
      return {
        ...state,
        filterPublicShippersData: action.payLoad?.data,
      };
    case shipperType.SEARCH_SHIPPERS:
      return {
        ...state,
        search: action.payLoad?.data,
      };

    case shipperType.LOADING_PUBLIC_SHIPPERS:
      return {
        ...state,
        loading: action.payLoad,
      };
    case shipperType.FILTERING:
      return {
        ...state,
        filtering: action.payLoad,
      };
    case shipperType.FILTER_SHIPPERS_NOPAGE:
      return {
        ...state,
        filterNoPage: action.payLoad?.data,
      };
    case shipperType.LOADING_SEARCH:
      return {
        ...state,
        searching: action.payLoad,
      };
    case shipperType.STORE_CURRENT_SHIPPER:
      return {
        ...state,
        setShipper: action.payLoad,
      };

    default:
      return state;
  }
}
